module.exports = __webpack_public_path__ + "static/logo_cypheme_nb-c4490f33f956fa31c11c1a53b5f6cb3a.svg";